export default function findAccess(
  books,
  currentBookId,
  hasLoggedIn,
  accessLevel
) {
  let hasAccess = false;

  if (currentBookId && hasLoggedIn) {
    if (accessLevel > 0) {
      hasAccess = true;
    }

    if (books && Array.isArray(books)) {
      for (let i = 0; i < books.length; i++) {
        if (JSON.stringify(books[i]) === currentBookId) {
          hasAccess = true;
          break;
        }
      }
    }
  }

  return hasAccess;
}



// WEBPACK FOOTER //
// ./src/utils/findAccess.js